import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
  BdcService
} from '../../services/service-bdc.service';

@Component({
  selector: 'app-modal-new-client',
  templateUrl: './modal-new-client.component.html',
  styleUrls: ['./modal-new-client.component.scss']
})
export class ModalNewClientComponent implements OnInit {
  nom = "";

  constructor(public activeModal: NgbActiveModal, private BdcService: BdcService, private router: Router) { }

  ngOnInit() {
  }

  addBailleur() {
    if (this.nom !== '') {
      this.BdcService.newClient(this.nom).then((client: any) => {
        console.log(client)
        this.activeModal.close();
        this.router.navigate(['bailleurs/marches/' + client.id]);
      });
    }
  }

  cancel() {
    this.activeModal.close();
  }

}

